import React from "react";

//interfaces and helpers
import { IContentPreviewCarouselControls } from "../../../../interfaces/media/IContentPreviewCarousel";
import { IconLibrary } from "../../../../interfaces/icon/IconLibrary";

//component
import IconButton from "../../buttons/IconButton";



const ContentCarouselControls = ({currentItem, totalItems, isPaused, onPlayButtonClick, onLeftClick, onRightClick}: IContentPreviewCarouselControls) => {      
    return (
        <div className={`content-preview-carousel-controls`}>
            <div className="carousel-play-pause-controls">
                <IconButton 
                    className="carousel-play-pause-button"
                    ariaLabel={isPaused ? "Play Carousel" : "Pause Carousel"} 
                    iconName={isPaused ? IconLibrary.PLAY : IconLibrary.PAUSE}
                    onButtonClick={onPlayButtonClick}
                />
            </div>

            <div className="carousel-count-information">
                {currentItem +1}
                {" "}
                of
                {" "}
                {totalItems}
            </div>

            <div className="left-right-controls">
                <IconButton 
                    className="carousel-left-button"
                    ariaLabel={"View Previous Item"} 
                    iconName={IconLibrary.CHEVRON_RIGHT}
                    onButtonClick={onLeftClick}
                />
    
                <IconButton 
                    className="carousel-right-button"
                    ariaLabel={"View Next Item"} 
                    iconName={IconLibrary.CHEVRON_RIGHT}
                    onButtonClick={onRightClick}
                />
            </div>
        </div>
    );
};

export default ContentCarouselControls;
